import { render, staticRenderFns } from "./AccordionTab.vue?vue&type=template&id=2b66187d"
import script from "./AccordionTab.vue?vue&type=script&lang=js"
export * from "./AccordionTab.vue?vue&type=script&lang=js"
import style0 from "./AccordionTab.vue?vue&type=style&index=0&id=2b66187d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports